(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"] && !Shopify.designMode) return;
  try {
    
function welchFooterResponsive(){document.querySelectorAll('.welch-footer__links').forEach(function(item){item.open=window.matchMedia('(min-width:750px)').matches;});}
welchFooterResponsive();
window.matchMedia('(min-width:750px)').addEventListener('change',welchFooterResponsive);
document.addEventListener('shopify:section:load',welchFooterResponsive);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('welch-announcement-rating')) {
    customElements.define('welch-announcement-rating', class extends HTMLElement {
      async connectedCallback() {
        try {
          const response = await fetch('https://welch-reviews.gareth-shaw.workers.dev/reviews', { credentials: 'omit', signal: AbortSignal.timeout(8000) });
          if (!response.ok) return;
          const data = await response.json();
          const age = Date.now() - Date.parse(data.updatedAt);
          if (!Number.isFinite(data.averageRating) || data.averageRating < 1 || data.averageRating > 5 || !Number.isFinite(age) || age > 604800000 || age < -300000) return;
          this.querySelector('[data-rating-value]').textContent = data.averageRating.toFixed(1);
          this.hidden = false;
        } catch {}
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welch-google-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('welch-review-carousel'))customElements.define('welch-review-carousel',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.welch-reviews__track');this.controls=this.querySelector('.welch-reviews__controls');if(!this.track||!this.controls)return;
  this.controller=new AbortController();const options={signal:this.controller.signal};
  this.controls.addEventListener('click',event=>{const button=event.target.closest('button[data-direction]');if(!button)return;const card=this.track.querySelector('article');this.track.scrollBy({left:Number(button.dataset.direction)*((card?.getBoundingClientRect().width||this.track.clientWidth)+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});},options);
  this.update=()=>{const max=this.track.scrollWidth-this.track.clientWidth;this.controls.hidden=max<2;this.controls.querySelector('[data-direction="-1"]').disabled=this.track.scrollLeft<2;this.controls.querySelector('[data-direction="1"]').disabled=this.track.scrollLeft>=max-2;};
  this.track.addEventListener('scroll',this.update,options);this.observer=new ResizeObserver(this.update);this.observer.observe(this.track);this.update();if(this.dataset.reviewsUrl)this.loadReviews();
 }
 async loadReviews(){
  const section=this.closest('.welch-reviews');
  try{
   const response=await fetch(this.dataset.reviewsUrl,{credentials:'omit',signal:AbortSignal.timeout(8000)});
   if(!response.ok)return;
   const data=await response.json();
   if(!this.isConnected||!Number.isFinite(data.averageRating)||!Number.isInteger(data.totalReviewCount)||!Array.isArray(data.reviews)||!data.reviews.length)return;
   const age=Date.now()-Date.parse(data.updatedAt);if(!Number.isFinite(age)||age<0||age>=7*86400000)return;
   const cards=document.createDocumentFragment();
   const make=(tag,text,className)=>{const el=document.createElement(tag);if(text!==undefined)el.textContent=text;if(className)el.className=className;return el;};
   for(const review of data.reviews){
    if(review.rating!==5||typeof review.text!=='string'||typeof review.author!=='string')continue;
    const card=make('article',undefined,'welch-reviews__card');
    const header=make('header');const initial=make('span',review.author.slice(0,1).toUpperCase(),'welch-reviews__initial');initial.setAttribute('aria-hidden','true');
    const details=make('div');details.append(make('h3',review.author));
    const date=new Date(review.date);if(!Number.isNaN(date.getTime()))details.append(make('small',date.toLocaleDateString('en-GB',{month:'long',year:'numeric'})));
    header.append(initial,details,this.querySelector('[data-google-source]').content.cloneNode(true));card.append(header);
    const stars=make('p',undefined,'welch-reviews__stars');const icons=make('span','★★★★★');icons.setAttribute('role','img');icons.setAttribute('aria-label','5 out of 5 stars');stars.append(icons,this.querySelector('[data-google-tick]').content.cloneNode(true));
    const quote=make('blockquote',review.text);quote.style.whiteSpace='pre-line';card.append(stars);
    if(review.text.length>190){
      const excerpt=make('blockquote',review.text.slice(0,190).replace(/\s+\S*$/,'')+'…','welch-reviews__excerpt');
      const full=make('details');const toggle=make('summary','Read full review');full.append(toggle,quote);
      full.addEventListener('toggle',()=>{toggle.textContent=full.open?'Show less':'Read full review';});
      card.append(excerpt,full);
    }else card.append(quote);
    cards.append(card);
   }
   if(!cards.childNodes.length)return;
   this.track.replaceChildren(cards);
   const summary=section.querySelector('.welch-reviews__summary');
   const rating=summary.querySelector('.welch-reviews__rating');if(rating){rating.replaceChildren(document.createTextNode(data.averageRating.toFixed(1)+' '),make('small','/ 5'));}
   const count=summary.querySelector('.welch-reviews__rating + p');if(count)count.textContent=data.totalReviewCount+' reviews on Google';
   const checked=summary.querySelector(':scope > small');if(checked)checked.textContent='Rating checked '+new Date(data.updatedAt).toLocaleDateString('en-GB',{day:'numeric',month:'long',year:'numeric'});
   const link=summary.querySelector('a');if(link)link.href='https://maps.google.com/maps?cid=14069844686444148601';
   section.querySelector('.welch-reviews__layout').hidden=false;section.querySelector('.welch-reviews__fallback').hidden=true;this.update();
  }catch{}
 }
 disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();}
});

  } catch(e) { console.error(e); }
})();
})();
